import { useSyncExternalStore } from 'react';

/**
 * Words a page puts in the composer for the user to send or change — held in
 * the module for the same reason the drawer's own state is: the page that
 * writes them and the panel that shows them are nowhere near each other in the
 * tree. Numbered so the same words handed over twice land twice.
 */
export interface ChatDraft {
  text: string;
  /** Goes up with every draft; what the composer keys its take on. */
  id: number;
}

const NONE: ChatDraft = { text: '', id: 0 };

let draft: ChatDraft = NONE;

const listeners = new Set<() => void>();

/** Put these words in the composer, unsent, with the caret after them. */
export function draftChatMessage(text: string): void {
  draft = { text, id: draft.id + 1 };
  listeners.forEach((listener) => listener());
}

/** The latest draft, as it stands. */
export function currentChatDraft(): ChatDraft {
  return draft;
}

/** Drops what was drafted. For tests, which share the module. */
export function forgetChatDraft(): void {
  draft = NONE;
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

/** The draft, as the drawer reads it: reactively, from wherever it is drawn. */
export function useChatDraft(): ChatDraft {
  return useSyncExternalStore(subscribe, currentChatDraft, () => NONE);
}
